import type {
  SchemaDisplayMetadata,
  SchemaDisplayMetadataPatch,
} from '@reach/shared-types/schema-mappings';

export function toIconColorMetadataPatch(metadata: SchemaDisplayMetadata): SchemaDisplayMetadataPatch {
  return {
    icon: metadata.icon ?? null,
    color: metadata.color ?? null,
  };
}
